export default {
  // 'apiUrl': 'https://ky-dev.wecandevelopit.com',
  // 'apiUrl': 'https://ky-demo.wecandevelopit.com',
  'apiUrl': 'https://ky-stage.wecandevelopit.com',
  // 'apiUrl': 'https://boots.kolyom.co.il',
  'version': '/api/v1',
  'defaultLang': 'en',
  'appName': 'Kol-Yom',
  'appEmail': 'info@kolyom.co.il',
  'notificationsLoop': 300000,
  // 'notificationsSocket': 'wss://app.kolyom.co.il:8443'
  'notificationsSocket': 'wss://ky-dev.wecandevelopit.com:8443'
}



// WEBPACK FOOTER //
// ./src/settings.js